module.exports = __webpack_public_path__ + "static/img/iPhone7.ddfa2b47.png";